
import VLazyImage from 'v-lazy-image'

export default {
  name: 'SectionHome',

  components: {
    VLazyImage,
  },
}
